module.exports = __webpack_public_path__ + "static/img/kjdy14.84e94da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/kjdy14.png
// module id = 329
// module chunks = 0